import Http from '@/utils/http'

const PASSENGER_ENDPOINT = '/passengers/'

export const postPassenger = (data) => Http.post(PASSENGER_ENDPOINT, data)

export const postOfflinePassenger = (data) => Http.post(`${PASSENGER_ENDPOINT}offline/`, data)

export const getPassenger = (id) => {
  return Http.get(`${PASSENGER_ENDPOINT + id}/`)
}
export const getPassengers = (queryParams) => Http.get(`${PASSENGER_ENDPOINT}?${queryParams}`)

export const deletePassenger = (id) => {
  return Http.delete(`${PASSENGER_ENDPOINT + id}/`)
}
export const putPassenger = (data) => {
  return Http.put(`${PASSENGER_ENDPOINT + data.id}/`, data)
}

export const getBookedSeats = (route, depDate, bySection) => {
  const d = depDate || new Date()
  return Http.get(`${PASSENGER_ENDPOINT}booked-seats/?dep_date=${d}&route=${route}${bySection}`)
}

export const checkPassengerInfo = (data) => {
  return Http.post(`${PASSENGER_ENDPOINT}check-details/`, data)
}

export const validateCheckout = (data) => {
  return Http.post('validate-checkout/', data)
}

export const validateBusCharter = (data) => {
  return Http.post('validate-bus-charter/', data)
}

export const injectPassenger = (data) => {
  return Http.post(`${PASSENGER_ENDPOINT}inject/`, data)
}



// WEBPACK FOOTER //
// ./src/services/passenger.js